import axiosInstance from "./axiosInstance";

const uploadService = {
  single: async (file) => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/upload/image",
        formData
      );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  editorImage: async (file) => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "admin/users/upload/image",
        formData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default uploadService;
